// Feature: M004-F0712. Tests: T-M004-0203.
//
// The seam between the TX chip (M004-F0712) and the transaction history drawer (M004-F0713, a different lane). The
// history lane's `TxHistoryProvider` supplies `{ openTransaction({ key, orgId, customerUserId, handOffId }) }` through this
// context; the chip only reads it. With no provider mounted the value is null and every chip is copy-only (design 1.2 mode 1),
// so the chip contract can ship and be tested before the drawer exists.
import { createContext, useContext } from 'react';

export const TxHistoryContext = createContext(null);
export const useTxHistory = () => useContext(TxHistoryContext);
